// JZ General (https://jzyxgames.feishu.cn/wiki/wikcnxnzf6zyK2NoHxTdEEKl3cb)
import JZGeneral from '@jz/general'

export default ({ store, query, $config, route }) => {
  const { source } = store.state
  const { NUXT_ENV_API } = $config
  JZGeneral(
    { debug: NUXT_ENV_API, extendId: 'jzyx_about_culture_next' },
    (generalObj) => {
      // 当服务器未请求到数据时，将插件获取到的数据存储起来
      if (!source) store.dispatch('SetSource', generalObj.source)
      // 通过路由传参控制 footer 的显示
      const { foot } = query
      if (window.self === window.top && !foot) {
        // 检查是否为着陆页
        if (route.name === 'index-v2' || route.name === 'landing') {
          // 自定义 footer 容器
          // const footerContainer = document.getElementById('landing-footer')
          // if (footerContainer) {
          //   generalObj.footer({
          //     container: footerContainer,
          //   })
          // }
        } else {
          // 其他页面使用默认配置
          generalObj.footer({ top: true })
        }
      }
    }
  )
}
